import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Returninvoice} from './returninvoices';

@Injectable()
export class ReturninvoiceService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('returninvoices?' + params.toString()).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('org/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('returninvoices/logo').map((response: Response) => response.json());
    }

  getByIdinv(_id: string) {
    return this.http.get('invoices/' + _id).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('returninvoices/' + _id).map((response: Response) => response.json());
  }


  getTrashedById(_id: string) {
        return this.http.get('returninvoices/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('returninvoices/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(returninvoice: Returninvoice) {
        return this.http.post('returninvoices', returninvoice).map((response: Response) => response.json());
    }

    update(returninvoice: Returninvoice) {
        return this.http.put('returninvoices/' + returninvoice.id, returninvoice).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('returninvoices/' + _id).map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pos/returninvoices/returninvoices.service.ts